import "rc-progress/assets/index.css";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Line, Circle } from "rc-progress";

import "./circleProgressBar.scss";

const CircleProgressBar = ({
  strokeColor,
  strokeWidth,
  trailColor,
  progress
}) => {
  if (progress > 0) {
    return (
      <div className="circle-progress-bar">
        <span className="circle-progress-bar__progress-text">
          {`${progress} %`}
        </span>
        <Circle
          percent={progress}
          strokeWidth={strokeWidth}
          strokeColor={strokeColor}
          trailWidth={strokeWidth}
          trailColor={trailColor}
        />
      </div>
    );
  }
  return null;
};

CircleProgressBar.propTypes = {
  /** The width of the progress bar */
  barWidth: PropTypes.string,
  progress: PropTypes.number.isRequired,
  /** The width of the stroke bar */
  strokeWidth: PropTypes.string
};

CircleProgressBar.defaultProps = {
  barWidth: "100%",
  strokeWidth: "0.75",
  strokeColor: "#15c4ab",
  trailColor: "#3f3f3f",
  trailWidth: "0.75"
};

export default CircleProgressBar;
